<template>
  <div>
    <div class="row menubar">
      <button @click="dashboard">
        <awesomeIcon icon="angle-left" />
        <span class="mobile-hidden">Terug naar overzicht</span>
      </button>
      <button @click="uploadToggle = true">
        <awesomeIcon icon="upload" />
        <span class="mobile-hidden">Veilig uploaden</span>
      </button>
      <inputDropdown
        :array="dropdown"
        v-model="dropdownValue"
        :defaultIndex="1"
        style="float: right"
      />
    </div>
    <div key="files" id="reports" class="card" v-if="files !== null">
      <div v-if="files.length == 0 && $parent.other === 'reportOverview'" class="msg">
        <awesomeIcon icon="exclamation-circle" /> Er staan voor u nog geen rapportages online!
      </div>
      <table v-else class="new click-tr printhide">
        <thead class="table-legend">
          <tr>
            <th>Datum</th>
            <th colspan="2">Naam</th>
          </tr>
        </thead>
        <tr
          v-for="(file, index) in combinedFiles"
          :key="index"
          @click="clickActionOnFile(file)"
        >
          <td>{{ file.stringDate }}</td>
          <td>{{ file.objName }}</td>
          <td class="link">
            <span class="hide-mobile">Bekijk</span>
            <awesomeIcon icon="search" />
          </td>
        </tr>
      </table>

      <!-- upload -->
      <modalWindow v-if="uploadToggle" @close="uploadToggle = false" width="300">
        <div class="titlebar">Veilig bestanden uploaden</div>
        <div class="form-notice" v-if="tooltipText">
          {{ tooltipText }}
        </div>
        <div class="inset">
          <label for="img" class="file-label button" style="display:block; height:initial;">
            <awesomeIcon icon="upload" /> Bestanden uploaden
          </label>
          <input
            style="display:none;"
            ref="files"
            type="file"
            name="img"
            multiple
            @change="uploadFilesChanged"
          />
        </div>
      </modalWindow>

      <!-- plan -->
      <modalWindow v-if="planToggle" @close="planToggle=false" width="860" position="edge">
        <div class="titlebar">Beleggingsplan</div>
        <div class="viewport">
          <plan
            v-if="intakeAdmin.beleggen.brand !== 'Doelbeleggen'"
            :intake="intake"
            :intakeAdmin="intakeAdmin"
            :id="intakeId"
            :redo="redo"
            :portValue="portValue"
            :today="signDate ? new Date(signDate) : new Date()"
          />
          <planDB
            v-if="intakeAdmin.beleggen.brand == 'Doelbeleggen'"
            :intake="intake"
            :intakeAdmin="intakeAdmin"
            :redo="redo"
            :portValue="portValue"
            :id="intakeId"
            :today="signDate ? new Date(signDate) : new Date()"
          />
        </div>
        <div class="modalfooter">
          <span
            v-if="
              `${location}`.indexOf('http://') === -1 && `${location}`.indexOf('https://') === -1
            "
          >
            Printen is alleen mogelijk vanuit de site
          </span>
          <button style="float:right;" @click="windowPrint" v-else>
            Printen <awesomeIcon icon="print" />
          </button>
        </div>
      </modalWindow>

      <!-- collect -->
      <modalWindow v-if="collectToggle" @close="collectToggle=false" width="860" position="edge">
        <div class="titlebar">Doorlopende Machtiging</div>
        <div class="viewport">
          <collect
            :currentPort="currentPort"
            :intake="intake"
            :today="signDate ? new Date(signDate) : new Date()"
          />
        </div>
        <div class="modalfooter">
          <span
            v-if="
              `${location}`.indexOf('http://') === -1 && `${location}`.indexOf('https://') === -1
            "
          >
            Printen is alleen mogelijk vanuit de site
          </span>
          <button style="float:right;" @click="windowPrint" v-else>
            Printen <awesomeIcon icon="print" />
          </button>
        </div>
      </modalWindow>

    </div>
    <div key="loader" v-else class="loader"></div>
  </div>
</template>

<script>
import {
  find, reject, orderBy,
} from 'lodash-es';
import collect from './intake/collect';
import plan from './intake/plan';
import planDB from './intake/planDB';

export default {
  name: 'UserReports',
  components: {
    collect,
    plan,
    planDB,
  },
  data() {
    return {
      redo: null,
      portValue: '',
      intakeId: null,
      linkFiles: [],
      location: window.location,
      files: null,
      dropdownValue: 'reportOverview',
      dropdown: [
        {
          label: 'Overige',
          value: 'docOverview',
        },
        {
          label: 'Rapportages',
          value: 'reportOverview',
        },
      ],
      signDate: null,
      intake: {},
      intakeAdmin: {},
      collectToggle: false,
      planToggle: false,
      uploadToggle: false,
      tooltipText: '',
    };
  },
  created() {
    this.getFiles();
    this.loadIntake();
    this.createBrandArray();
    if (this.$parent.other) {
      this.dropdownValue = this.$parent.other;
    }
  },
  computed: {
    ports() {
      return this.$store.state.ports;
    },
    port() {
      return this.$store.state.currentPort;
    },
    currentPort() {
      return find(this.ports, { id: this.port });
    },
    role() {
      return this.$store.state.role;
    },
    collect() {
      return this.currentPort.cashflow.length > 0 ? this.currentPort.cashflow[0].collect : 0;
    },
    combinedFiles() {
      const files = [];
      if (this.$parent.other === 'docOverview') {
        const fileArray = reject(this.files, (obj) => (
          obj.type !== 'Kostenoverzicht'
          && obj.type !== 'Vergelijkende Kostenmaatstaf'
        ));
        for (let i = 0; i < fileArray.length; i += 1) {
          fileArray[i].stringDate = this.toTextDate(fileArray[i]);
          fileArray[i].orderDate = this.toOrderTextDate(fileArray[i]);
          fileArray[i].objType = 'download';
          fileArray[i].objName = fileArray[i].type;
          files.push(fileArray[i]);
        }
        if (Number(this.collect) === 1) {
          const tempObj = {};
          tempObj.stringDate = this.currentPort.intake_date.substring(0, 4);
          tempObj.orderDate = this.currentPort.intake_date.substring(0, 4);
          tempObj.objType = 'collect';
          tempObj.objName = 'Doorlopende machtiging';
          tempObj.path = this.currentPort.path ? this.currentPort.path : '';
          tempObj.brand = this.currentPort.brand;
          files.push(tempObj);
        }
        if (this.currentPort.brand === 'Doelbeleggen' || this.currentPort.brand === 'OXBY') {
          const tempObj = {};
          tempObj.stringDate = this.currentPort.intake_date.substring(0, 4);
          tempObj.orderDate = this.currentPort.intake_date.substring(0, 4);
          tempObj.objType = 'plan';
          tempObj.objName = 'Beleggingsplan';
          tempObj.path = this.currentPort.path ? this.currentPort.path : '';
          tempObj.brand = this.currentPort.brand;
          files.push(tempObj);
        }
        const linkArray = this.linkFiles;
        for (let i = 0; i < linkArray.length; i += 1) {
          linkArray[i].stringDate = linkArray[i].year;
          linkArray[i].orderDate = linkArray[i].year;
          linkArray[i].objType = 'link';
          linkArray[i].objName = linkArray[i].title;
          files.push(linkArray[i]);
        }
      } else {
        const fileArray = reject(this.files, (obj) => (
          obj.type === 'Kostenoverzicht'
          && obj.type === 'Vergelijkende Kostenmaatstaf'
        ));
        for (let i = 0; i < fileArray.length; i += 1) {
          fileArray[i].stringDate = this.toTextDate(fileArray[i]);
          fileArray[i].orderDate = this.toOrderTextDate(fileArray[i]);
          fileArray[i].objType = 'download';
          fileArray[i].objName = fileArray[i].type;
          files.push(fileArray[i]);
        }
      }
      return orderBy(files, ['orderDate'], ['desc']);
    },
  },
  watch: {
    dropdownValue() {
      this.$parent.other = this.dropdownValue;
    },
  },
  methods: {
    clickActionOnFile(file) {
      if (file.objType === 'download') {
        this.download(file.path);
      } else if (file.objType === 'collect') {
        this.showModal('collect');
      } else if (file.objType === 'plan') {
        this.showModal('plan');
      } else {
        window.open(file.link, '_blank');
      }
    },
    createBrandArray() {
      this.linkFiles = [];
      // brand check
      if (this.currentPort.brand === 'Doelbeleggen') {
        this.linkFiles.push(
          {
            year: '2019',
            title: 'Voorwaarden',
            link: 'https://www.doelbeleggen.nl/content/uploads/Voorwaarden-Doelbeleggen.pdf',
          },
        );
      } else if (this.currentPort.brand === 'BVS') {
        this.linkFiles.push(
          {
            year: '2019',
            title: 'Voorwaarden',
            link: 'https://beervanstapele.nl/content/uploads/2019/04/Voorwaarden-Beer-Van-Stapele_BvS.pdf',
          },
          {
            year: '2019',
            title: 'Klachtenprocedure',
            link: 'https://beervanstapele.nl/content/uploads/2018/06/Klachtenprocedure-v2.pdf',
          },
          {
            year: '2019',
            title: 'Orderuitvoeringsbeleid',
            link: 'https://beervanstapele.nl/content/uploads/2018/01/Orderuitvoeringsbeleid_BVS.pdf',
          },
          {
            year: '2019',
            title: 'Beleid belangenconflicten',
            link: 'https://beervanstapele.nl/content/uploads/2018/01/Beleid_Belangenconflicten.pdf',
          },
          {
            year: '2019',
            title: "Kenmerken en risico's effecten",
            link: 'https://beervanstapele.nl/content/uploads/2018/01/Kenmerken_van_effecten_en_daaraan_verbonden_specifieke_risicos.pdf',
          },
        );
      } else if (this.currentPort.brand === 'OXBY') {
        this.linkFiles.push(
          {
            year: 'Huidig',
            title: 'Voorwaarden',
            link: 'https://oxby.nl/content/uploads/Voorwaarden-Oxby.pdf',
          },
          {
            year: 'Huidig',
            title: 'Klachtenregeling',
            link: 'https://oxby.nl/content/uploads/Klachtenregeling.pdf',
          },
          {
            year: 'Huidig',
            title: 'Orderuitvoeringsbeleid',
            link: 'https://oxby.nl/content/uploads/Orderuitvoeringsbeleid.pdf',
          },
          {
            year: 'Huidig',
            title: 'Beleid belangenconflicten',
            link: 'https://oxby.nl/content/uploads/Regels-belangenconflicten.pdf',
          },
          {
            year: 'Huidig',
            title: 'Risico en kenmerken van effecten',
            link: 'https://oxby.nl/content/uploads/Risicos-en-kenmerken-van-effecten.pdf',
          },
        );
        if (this.currentPort.bank === 'GIRO') {
          this.linkFiles.push(
            {
              year: 'Huidig',
              title: 'Voorwaarden beleggingsrekening',
              link: 'https://oxby.nl/content/uploads/Voorwaarden-beleggingsrekening.pdf',
            },
          );
        }
      } else if (this.currentPort.brand === 'VMVB') {
        this.linkFiles.push(
          {
            year: '2019',
            title: 'Voorwaarden',
            link: 'https://velthuysemulder.nl/content/uploads/2019/04/Voorwaarden-Velthuyse-•-Mulder-Vermogensbeheer_VM.pdf',
          },
          {
            year: '2019',
            title: 'Klachtenprocedure',
            link: 'https://velthuysemulder.nl/content/uploads/Klachtenprocedure.pdf',
          },
          {
            year: '2019',
            title: 'Orderuitvoeringsbeleid',
            link: 'https://velthuysemulder.nl/content/uploads/Orderuitvoeringsbeleid.pdf',
          },
          {
            year: '2019',
            title: 'Beleid belangenconflicten',
            link: 'https://velthuysemulder.nl/content/uploads/Beleid_Belangenconflicten.pdf',
          },
          {
            year: '2019',
            title: "Kenmerken en risico's effecten",
            link: 'https://velthuysemulder.nl/content/uploads/Kenmerken_van_effecten_en_daaraan_verbonden_specifieke_risicos.pdf',
          },
        );
      }
      // Bank check
      if (this.currentPort.bank === 'GILI') {
        this.linkFiles.push(
          {
            year: '2019',
            title: 'Voorwaarden depotbank',
            link: 'https://velthuysemulder.nl/content/uploads/Tarieven_en_conditieoverzicht_InsingerGilissen.pdf',
          },
        );
      } else if (this.currentPort.bank === 'BNCK') {
        this.linkFiles.push(
          {
            year: '2019',
            title: 'Voorwaarden depotbank',
            link: 'https://velthuysemulder.nl/content/uploads/Tarieven_en_conditieoverzicht_BinckBank.pdf',
          },
        );
      }
    },
    uploadFilesChanged(e) {
      this.uploadFiles(e.target.files.length);
    },
    uploadFiles() {
      this.sdk.addFile(this.$refs.files.files, (response) => {
        if (response.status === 200) {
          // success
          this.tooltipText = 'We hebben uw bestanden ontvangen.';
        } else {
          this.tooltipText = 'Fout met uploaden. Wij accepteren alleen afbeeldingen en pdf bestanden.';
        }
      });
    },
    showModal(type) {
      if (this.intake.persoonsData) {
        if (type === 'collect') {
          this.collectToggle = true;
        }
        if (type === 'plan') {
          this.planToggle = true;
        }
      }
    },
    loadIntake() {
      this.sdk.getPortIntake(this.$store.state.currentPort, (response) => {
        if (response.status === 200) {
          this.signDate = response.data.complete_date;
          this.intakeId = response.data.id;

          const parsed = JSON.parse(response.data.intake);
          if (!parsed.version) {
            if (typeof parsed.goalData.extrarendement !== 'undefined') {
              parsed.goalData.extrarendement += 0;
            }
            if (parsed.persoonsData) {
              for (let i = 0; i < parsed.persoonsData.length; i += 1) {
                if (typeof parsed.persoonsData[i].hypotheekEigenWoningRente !== 'undefined') {
                  parsed.persoonsData[i].hypotheekEigenWoningRente += 0;
                }
                if (typeof parsed.persoonsData[i].hypotheekEigenWoning2Rente !== 'undefined') {
                  parsed.persoonsData[i].hypotheekEigenWoning2Rente += 0;
                }
                if (typeof parsed.persoonsData[i].hypotheekEigenWoning3Rente !== 'undefined') {
                  parsed.persoonsData[i].hypotheekEigenWoning3Rente += 0;
                }
                if (typeof parsed.persoonsData[i].hypotheekOnroerendGoedRente !== 'undefined') {
                  parsed.persoonsData[i].hypotheekOnroerendGoedRente += 0;
                }
                if (typeof parsed.persoonsData[i].hypotheekOnroerendGoed2Rente !== 'undefined') {
                  parsed.persoonsData[i].hypotheekOnroerendGoed2Rente += 0;
                }
                if (typeof parsed.persoonsData[i].hypotheekOnroerendGoed2Rente !== 'undefined') {
                  parsed.persoonsData[i].hypotheekOnroerendGoed2Rente += 0;
                }
              }
            }
          }
          for (let i = 0; i < parsed.persoonsData.length; i += 1) {
            if (
              parsed.persoonsData[i].geboorteDag
              && parsed.persoonsData[i].geboorteMaand
              && parsed.persoonsData[i].geboorteJaar
            ) {
              // create padded month through ISO
              const Datum = new Date(
                parsed.persoonsData[i].geboorteJaar,
                parsed.persoonsData[i].geboorteMaand - 1,
                parsed.persoonsData[i].geboorteDag,
                12,
              ).toISOString().split('T')[0];
              parsed.persoonsData[i].geboorteDatum = Datum;
              delete parsed.persoonsData[i].geboorteDag;
              delete parsed.persoonsData[i].geboorteMaand;
              delete parsed.persoonsData[i].geboorteJaar;
            }
          }
          this.redo = response.data.redo;
          this.portValue = find(this.ports, (o) => o.id === this.$store.state.currentPort).value;
          Object.assign(this.intake, parsed);
          Object.assign(this.intakeAdmin, JSON.parse(response.data.admin || '{}'));
          if (this.$parent.other === 'plan') {
            this.$nextTick(() => {
              this.$parent.other = 'docOverview';
              this.showModal('plan');
            });
          }
        } else {
          // show warning
        }
      });
    },
    toTextDate(file) {
      if (file.date.length === 4) {
        return file.date;
      }
      return file.date[4] === 'Q'
        ? `${file.realDate.getFullYear()} - kwartaal ${file.date[5]}`
        : `${file.realDate.getFullYear()} - ${file.realDate.toLocaleString('nl', {
          month: 'long',
        })}`;
    },
    toOrderTextDate(file) {
      if (file.date.length === 4) {
        return `${file.date} - z`;
      }
      return file.date[4] === 'Q'
        ? `${file.realDate.getFullYear()} - kwartaal ${file.date[5]}`
        : `${file.realDate.getFullYear()} - ${new Date(file.realDate).getTime()}`;
    },
    download(file) {
      this.sdk.getFile(this.$store.state.currentPort, file);
    },
    dashboard() {
      this.$store.state.currentView = 'Dashboard';
    },
    getFiles() {
      this.files = null;
      this.sdk.getFiles(this.$store.state.currentPort, (response) => {
        if (response.status === 200) {
          const nameResolve = (file) => {
            if (file.date.length === 6) {
              if (file.date[4] === 'Q') {
                return new Date(
                  file.date.substring(0, 4),
                  (parseInt(file.date.substring(5, 6), 10) - 1) * 3,
                  2,
                );
              }
              return new Date(
                file.date.substring(0, 4),
                parseInt(file.date.substring(4, 6), 10) - 1,
                1,
              );
            }
            if (file.date.length === 4) {
              return new Date(file.date.substring(0, 4), 11, 31);
            }
            return new Date(0);
          };
          response.data.sort((a, b) => {
            if (nameResolve(a) < nameResolve(b)) {
              return 1;
            }
            if (nameResolve(a) > nameResolve(b)) {
              return -1;
            }
            return 0;
          });

          for (let i = 0; i < response.data.length; i += 1) {
            response.data[i].realDate = nameResolve(response.data[i]);
            response.data[i].year = response.data[i].date.substring(0, 4);
          }

          this.files = response.data;
        } else {
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#reports {
  padding: 20px;
  @media #{$mobile} {
    padding: 1px 2px 2px;
  }
}
.link {
  text-align: right;
}
</style>
